(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const activeAnimations = new WeakMap();

  function enhanceFooter(footer) {
    if (!footer || footer.classList.contains('saba-footer')) return;
    const disclosures = [];
    footer.querySelectorAll('.footer-block--menu').forEach((block) => {
      const heading = block.querySelector('.footer-block__heading');
      const links = block.querySelector('.footer-block__details-content');
      if (!heading || !links) return;
      const details = document.createElement('details');
      details.className = 'saba-footer__disclosure';
      const summary = document.createElement('summary');
      summary.className = 'saba-footer__summary';
      const label = document.createElement('span');
      label.textContent = heading.textContent.trim();
      summary.append(label);
      summary.insertAdjacentHTML('beforeend', '<svg class="saba-footer__chevron" aria-hidden="true" focusable="false" viewBox="0 0 11 7" fill="none"><path d="M1 1L5.5 5.5L10 1" stroke="currentColor" stroke-width="1.5"/></svg>');
      const content = document.createElement('div');
      content.className = 'saba-footer__links';
      content.append(links);
      details.append(summary, content);
      block.append(details);
      disclosures.push(details);

      summary.addEventListener('click', (event) => {
        if (!mobile.matches) { event.preventDefault(); return; }
        if (reducedMotion.matches || !content.animate) return;
        event.preventDefault();
        // Ignore repeated activation while the short transition finishes.
        if (activeAnimations.has(details)) return;
        const closing = details.open;
        if (!closing) details.open = true;
        const height = content.getBoundingClientRect().height;
        content.style.overflow = 'hidden';
        const animation = content.animate([
          { height: closing ? `${height}px` : '0px', opacity: closing ? 1 : 0 },
          { height: closing ? '0px' : `${height}px`, opacity: closing ? 0 : 1 }
        ], { duration: 180, easing: 'ease-out' });
        activeAnimations.set(details, animation);
        animation.onfinish = () => {
          if (closing) details.open = false;
          content.style.removeProperty('overflow');
          activeAnimations.delete(details);
        };
        animation.oncancel = () => {
          content.style.removeProperty('overflow');
          activeAnimations.delete(details);
        };
      });
    });

    const newsletter = footer.querySelector('.footer-block__newsletter');
    if (newsletter) {
      const heading = newsletter.querySelector('.footer-block__heading');
      if (heading) heading.textContent = 'Newsletter';
      const form = newsletter.querySelector('form');
      if (form) {
        const copy = document.createElement('p');
        copy.className = 'saba-footer__newsletter-copy';
        copy.textContent = 'Be the first to discover new arrivals, styling inspiration and SABA updates.';
        form.before(copy);
        const consent = document.createElement('p');
        consent.className = 'saba-footer__consent';
        consent.append('By subscribing, you agree to our ');
        const privacy = document.createElement('a');
        const policyLink = footer.querySelector('a[href*="/policies/privacy-policy"]');
        privacy.href = policyLink ? policyLink.href : `${window.Shopify?.routes?.root || '/'}policies/privacy-policy`;
        privacy.textContent = 'Privacy Policy';
        consent.append(privacy, '.');
        form.after(consent);
        const input = form.querySelector('input[type="email"]');
        if (input) { input.placeholder = 'E-mail'; input.setAttribute('enterkeyhint', 'send'); }
        const submit = form.querySelector('button[type="submit"]');
        if (submit) {
          const text = document.createElement('span');
          text.textContent = 'Subscribe';
          submit.append(text);
        }
      }
    }

    footer.querySelectorAll('.footer-block__details-content.rte p').forEach((paragraph) => {
      // Turn the existing plain-text contact email into a useful tap target.
      const email = paragraph.textContent.trim();
      if (!paragraph.querySelector('a') && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        const anchor = document.createElement('a');
        anchor.href = `mailto:${email}`;
        anchor.textContent = email;
        paragraph.replaceChildren(anchor);
      }
    });

    const syncLayout = () => disclosures.forEach((details) => {
      activeAnimations.get(details)?.cancel();
      details.open = !mobile.matches;
    });
    syncLayout();
    mobile.addEventListener('change', syncLayout);
    footer.classList.add('saba-footer');
    // Theme Editor replaces section DOM; release listeners with the old section.
    footer.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      mobile.removeEventListener('change', syncLayout);
      disclosures.forEach((details) => activeAnimations.get(details)?.cancel());
    }, { once: true });
  }

  const init = (root = document) => {
    if (root.matches?.('footer.footer')) enhanceFooter(root);
    root.querySelectorAll('footer.footer').forEach(enhanceFooter);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  // Multiple section script executions must not accumulate editor listeners.
  if (!window.sabaFooterEditorListener) {
    window.sabaFooterEditorListener = true;
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }
})();
